// Regrid's nationwide parcel boundaries as served by Esri Living Atlas, in place
// of the legacy Regrid "Parcels" library group. Public raster tiles:
// no key and no session, so nothing is requested until the layer is visible.
// Inert until index.js passes the flag Rails rendered (esriParcelBoundaries).

export const ESRI_PARCELS_GROUP_ID = 'regrid'; // saved maps reference the group by this id
export const ESRI_PARCELS_LAYER_ID = 'esri_parcels';
export const ESRI_PARCELS_SOURCE_ID = 'esri-parcels';
export const ESRI_PARCELS_MIN_ZOOM = 15;

export const ESRI_PARCELS_CREDIT_PREFIX = 'Parcels: ';
export const ESRI_PARCELS_CREDIT_LINK_TEXT = 'Regrid';
export const ESRI_PARCELS_CREDIT_URL = 'https://regrid.com';

const TILE_URL =
    'https://tiles.arcgis.com/tiles/KzeiCaQsMoeCfoCq/arcgis/rest/services/' +
    'Regrid_Nationwide_Parcel_Boundaries_v1/MapServer/tile/{z}/{y}/{x}';
const ITEM_URL = 'https://www.arcgis.com/home/item.html?id=a2050b09baff493aa4ad7848ba2fac00';
// The service has tiles at z15-17 only; the renderer overzooms 17 above that.
const MAX_TILE_ZOOM = 17;
const DEFAULT_CATEGORY = 'Featured layers';

let enabled = false;
let lookupEnabled = false;

export function configureEsriParcels(flag) {
    enabled = flag === true;
}

export function isEsriParcelsEnabled() {
    return enabled;
}

// Click-for-parcel details on the outlines; Rails only sends it with the outlines flag.
export function configureEsriParcelLookup(flag) {
    lookupEnabled = flag === true;
}

export function isEsriParcelLookupEnabled() {
    return lookupEnabled;
}

export function buildEsriParcelsGroup(category) {
    return {
        id: ESRI_PARCELS_GROUP_ID,
        metadata: {
            category,
            title: 'Parcels',
            description:
                'Parcel boundaries across the United States. Click a parcel for its details where the state publishes them.',
            latestUpdate: 'Refreshed regularly by Regrid',
            source: { label: 'Regrid via Esri Living Atlas', link: ITEM_URL },
            visibility: `From zoom level ${ESRI_PARCELS_MIN_ZOOM}`,
            interactivity: false,
            classes: [
                {
                    'layer-group-id': ESRI_PARCELS_GROUP_ID,
                    type: 'square',
                    style: { color: '#b2b2b2' },
                    label: 'Parcel boundaries',
                },
            ],
        },
        sources: {
            [ESRI_PARCELS_SOURCE_ID]: {
                type: 'raster',
                tiles: [TILE_URL],
                tileSize: 256,
                minzoom: ESRI_PARCELS_MIN_ZOOM,
                maxzoom: MAX_TILE_ZOOM,
            },
        },
        layers: [
            {
                id: ESRI_PARCELS_LAYER_ID,
                type: 'raster',
                source: ESRI_PARCELS_SOURCE_ID,
                minzoom: ESRI_PARCELS_MIN_ZOOM,
                metadata: {
                    socialexplorer: { 'layer-group-id': ESRI_PARCELS_GROUP_ID, title: 'Parcels' },
                },
                layout: { visibility: 'none' },
                paint: { 'raster-opacity': 0.9 },
            },
        ],
    };
}

/** Swaps the legacy group for the Esri one (or appends it), only when enabled. */
export function applyEsriParcels(groups, isEnabled) {
    if (!isEnabled) return groups;
    const index = groups.findIndex(group => group && group.id === ESRI_PARCELS_GROUP_ID);
    if (index === -1) return [...groups, buildEsriParcelsGroup(DEFAULT_CATEGORY)];
    const category = (groups[index].metadata || {}).category || DEFAULT_CATEGORY;
    return groups.map((group, i) => (i === index ? buildEsriParcelsGroup(category) : group));
}
